import { z } from 'zod';

export const changeRequestFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(3, 'Title must be at least 3 characters')
    .max(30, 'Title must be 30 characters or less'),
  description: z
    .string()
    .trim()
    .min(3, 'Description must be at least 3 characters')
    .max(1000, 'Description must be 1000 characters or less'),
});

export type ChangeRequestFormData = z.infer<typeof changeRequestFormSchema>;
